// extracted by mini-css-extract-plugin
export default {"buttonSize":"ServicoIndisponivelModal_buttonSize__1M4cg","textSize":"ServicoIndisponivelModal_textSize__PhDF8"};